// extracted by mini-css-extract-plugin
export default {"DashboardTabEmptyStateContainer":"styles_DashboardTabEmptyStateContainer__QadLH","img":"styles_img__h3Jeu","DashboardTabEmptyStateTitle":"styles_DashboardTabEmptyStateTitle__B3iZt"};